<ng-container
  [formGroup]="showInactiveForm">
  <yc-checkbox
    name="showInactive"
    [optionLabel]="showInactiveText"
    [centerLabel]="true"
    (onChange)="_changeMade()">
  </yc-checkbox>
</ng-container>